import React from "react";
import Paragraph from "../Atoms/Paragraph";

const ContactoDudasBanner = () => {
    return (
        <Paragraph>
            <strong>¿Tenés dudas?</strong> Comunicate al <strong>(011) 5199-4787</strong> de Lunes a {' '}
            Viernes de 8 a 20hs y Sábados de 8 a 14hs.
        </Paragraph>
    );
};

export default ContactoDudasBanner;
